<template>
  <div class="nav-button">
    <el-button
        @click="action"
        :style="style"
    >
      <span>
        <i v-if="icon" :class="icon" />
        {{ title }}
      </span>
      <span>
        <i class="el-icon-arrow-right"></i>
      </span>
    </el-button>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NavButton',
  props: {
    icon: {
      type: String
    },
    title: {
      required: true,
      type: String
    },
    action: {
      required: true
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    style () {
      return {
        'color': `${this.estilo.aplicacao.corPrimariaAplicacao} !important`
      }
    }
  }
}
</script>
